import { useTranslation } from 'react-i18next';

import type { AutosaveStatus } from '../hooks/useAutosave';

// AutosaveStatusBadge renders the current autosave state in a small
// inline label — "Saving… / Saved / Save failed". Designed for use in
// panel headers next to a section title; deliberately understated so
// it doesn't fight the primary content for attention.

export function AutosaveStatusBadge({
  status,
  error,
}: {
  status: AutosaveStatus;
  error: string | null;
}) {
  const { t } = useTranslation('common');
  if (status === 'idle') return null;
  if (status === 'pending') {
    return (
      <span className="autosave-status autosave-status--pending" aria-live="polite">
        {t('autosave.pending')}
      </span>
    );
  }
  if (status === 'saved') {
    return (
      <span className="autosave-status autosave-status--saved" aria-live="polite">
        {t('autosave.saved')}
      </span>
    );
  }
  return (
    <span className="autosave-status autosave-status--failed" role="alert">
      <span className="autosave-status__label">{t('autosave.failed')}</span>
      {error && (
        <span className="autosave-status__detail" title={error}>
          {error}
        </span>
      )}
    </span>
  );
}
